import { Info, X } from 'react-feather'
import toast from 'react-hot-toast'

export const notificationToast = (msg: string, duration = 3000) => {
  toast.custom(
    t => (
      <div
        className={`flex items-center justify-between bg-coal-dark text-white text-sm font-medium rounded-[20px] p-[10px] shadow-md mt-[100px] ${
          t.visible ? 'animate-enter' : 'animate-leave'
        }`}
        style={{
          animationDuration: `${duration}ms`
        }}
      >
        <div className='flex items-center gap-2 mr-3'>
          <Info size={16} />
          <span className='font medium text-sm'>{msg}</span>
        </div>
        <button onClick={() => toast.dismiss(t.id)} className='text-white hover:text-gray-300 focus:outline-none'>
          <X size={16} />
        </button>
      </div>
    ),
    { duration }
  )
}
